import * as React from 'react';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import { AmazonKeyConfiguration } from '../../../../../api/PropertyIntegration';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

interface Props {
    config?: AmazonKeyConfiguration;
    update: (newConfig?: AmazonKeyConfiguration) => void;
}

const AmazonKeyConfigurationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();
    return(
    <CollapsibleCard
        cardTitle="Amazon Key Configuration"
        cardOpen={!!props.config}
        collapseStyle={{ display: 'none' }}
        onCardOpenChange={open =>{
            if (isUser)  return; props.update(open ? { keyPlaceId: '' } : undefined)}}
    >
        <div></div>
    </CollapsibleCard>
);
};
export default AmazonKeyConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/AmazonKeyConfigurationSection.tsx